import { io, Socket } from 'socket.io-client';
import { API_ENDPOINTS } from '~/utils/constants';

interface AuthAction {
  type: 'CONNECT_AGENT_WEBHOOK_SOCKET' | 'DISCONNECT_AGENT_WEBHOOK_SOCKET';
  payload: any;
}

const connectSocket = (endpoint: string): Socket => {
  const socket = io(endpoint, {
    transports: ['websocket', 'polling'],
  });

  return socket;
};

const socketReducer = (state: any = { webhook_con: false }, action: AuthAction) => {
  switch (action.type) {
    case 'CONNECT_AGENT_WEBHOOK_SOCKET':
      return { ...state, webhook_con: connectSocket(`${API_ENDPOINTS.KARLA_FLASK_API}/conversation/agent/webhooks`) };
    case 'DISCONNECT_AGENT_WEBHOOK_SOCKET':
      if (state.webhook_con) {
        state.webhook_con.disconnect();
      }
      return { ...state, webhook_con: false };
    default:
      return state;
  }
};

export default socketReducer;
